export const getQueryUrl = (payload: {
  url: string;
  queryObj?: {
    [key: string]: any;
  };
}) => {
  const { url, queryObj } = payload;

  if (!queryObj) {
    return url;
  }

  const keys = Object.keys(queryObj);

  let queryString = '';

  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];

    if (queryObj[key]) {
      queryString += `${queryString ? '&' : '?'}${key}=${queryObj[key]}`;
    }
  }

  return `${url}${queryString}`;
};
